export function findDefaultValueForComponent(
  assesmentComponentData,
  controlsList
) {
  let embedDefaultValue = {}
  if (
    Object.keys(assesmentComponentData).length > 0 &&
    controlsList &&
    controlsList.length > 0
  ) {
    const defltVal = controlsList.find(
      (c) => c.CtlId === assesmentComponentData.ControlID
    )
    embedDefaultValue = defltVal
      ? {
          ...defltVal,
          CtlValue: defltVal.CtlValue.Answer
        }
      : undefined
    return embedDefaultValue
  }
}
